import React, { Component } from "react";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import { Field, reduxForm } from "redux-form";
import _ from "lodash";
import { Translate, I18n } from "react-redux-i18n";
import WizardActionButtons from "../../Wizard/WizardActionButtons";
import Utilities from "../../../Helpers/Utilities";
import { getXsrfToken } from "../../../Store/Security/Actions";
import { toggleBlockingStatus } from "../../../Store/Status/Actions";
import { getUserInfo, register } from "../../../Store/Account/Actions";
import { getStates, getAddresses } from "../../../Store/Checkout/Actions";

class CreateAccountForm extends Component {
    constructor(props) {
        super(props);

        this.renderCountries = this.renderCountries.bind(this);
        this.renderStates = this.renderStates.bind(this);
        this.onCountryChange = this.onCountryChange.bind(this);
    }

    renderTextField(field) {
        const { meta: { touched, error } } = field;
        const className = `col-md-${field.size} ${touched && error ? "has-error" : ""}`;

        return (
            <div className={className}>
                <label>{field.label}</label>
                <input type={field.type} placeholder={field.placeholder} {...field.input} />
                <span className="help-block float-left">{touched ? error : ""}</span>
            </div>
        );
    }

    renderCountries() {
        const { countries } = this.props;

        if (countries.length > 0) {
            return _.map(countries, country =>
                <option key={country.countryId} value={country.countryId}>{country.countryName}</option>
            );
        }
    }

    renderStates() {
        const { states } = this.props;

        if (states.length > 0) {
            return _.map(states, state =>
                <option key={state.stateId} value={state.stateId}>{state.stateName}</option>
            );
        }
    }

    onCountryChange(countryId) {
        const { getStates } = this.props;

        getStates(countryId);
    }

    renderErrors() {
        if (this.props.registerStatus.response) {
            const { response: { data } } = this.props.registerStatus;
            if (data) {
                this.props.toggleBlockingStatus(false);

                return (
                    <div className="col-md-12">
                        <div className="alert bg--error" style={{ marginBottom: 0 }}>
                            <div className="alert__body">
                                <span>{data}</span>
                            </div>
                        </div>
                    </div>
                );
            }
        }
    }

    onSubmit(values) {
        const { getXsrfToken, register, getUserInfo, goNext, getAddresses } = this.props;

        let countryId = values.CountryId;
        let stateId = values.StateId;
        let countryName = null;
        let stateName = null;

        const countryElement = document.getElementsByName("CountryId")[0];
        const stateElement = document.getElementsByName("StateId")[0];

        if (!values.CountryId && countryElement) {
            countryId = countryElement.value;
        }

        if (!values.StateId && stateElement) {
            stateId = stateElement.value;
        }

        if (countryElement) {
            countryName = countryElement.options[countryElement.selectedIndex].text;
        }

        if (stateElement) {
            stateName = stateElement.options[stateElement.selectedIndex].text;
        }

        const obj = {
            FirstName: Utilities.toTitleCase(values.FirstName).trim(),
            LastName: Utilities.toTitleCase(values.LastName).trim(),
            UserName: Utilities.toTitleCase(values.UserName).trim(),
            Company: Utilities.toTitleCase(values.Company).trim(),
            PhoneNumber: values.PhoneNumber,
            Password: values.Password,
            ConfirmPassword: values.ConfirmPassword,
            CountryId: countryId,
            CountryName: countryName,
            StateProvinceId: stateId,
            StateProvinceName: stateName,
            City: Utilities.toTitleCase(values.City).trim(),
            Address1: Utilities.toTitleCase(values.Address1).trim(),
            Address2: Utilities.toTitleCase(values.Address2 || "").trim(),
            ZipPostalCode: values.ZipPostalCode.trim()
        };

        getXsrfToken(({ token }) => {
            obj.__RequestVerificationToken = token;

            register(obj, () => {
                getAddresses();
                getUserInfo(goNext);
            });
        });
    }

    render() {
        const { handleSubmit, submitting, countries, states, goPrev, wizardName } = this.props;

        return (
            <form className="container" onSubmit={handleSubmit(this.onSubmit.bind(this))}>
                <div className="row justify-content-around">
                    <div className="col-md-8 col-lg-7">
                        <ul>
                            <li><strong className="text-uppercase"><Translate value="checkout.wizard.steps.zero.message1" />:</strong> <Translate value="checkout.wizard.steps.zero.message2" /></li>
                        </ul>
                    </div>
                </div>
                <div className="row">
                    <div className="col-12">
                        <div className="row" style={{ marginTop: 20 }}>
                            <div className="col-md-6">
                                <div className="row">
                                    <Field
                                        name="FirstName"
                                        type="text"
                                        label={I18n.t("account.firstName")}
                                        placeholder={I18n.t("account.firstName")}
                                        size="12"
                                        component={this.renderTextField}
                                    />
                                    <Field
                                        name="LastName"
                                        type="text"
                                        label={I18n.t("account.lastName")}
                                        placeholder={I18n.t("account.lastName")}
                                        size="12"
                                        component={this.renderTextField}
                                    />
                                    <Field
                                        name="UserName"
                                        type="text"
                                        label={I18n.t("account.email")}
                                        placeholder={I18n.t("account.email")}
                                        size="12"
                                        component={this.renderTextField}
                                    />
                                    <Field
                                        name="Company"
                                        type="text"
                                        label={I18n.t("account.company")}
                                        placeholder={I18n.t("account.company")}
                                        size="12"
                                        component={this.renderTextField}
                                    />
                                    <Field
                                        name="PhoneNumber"
                                        type="text"
                                        label={I18n.t("account.phoneNumber")}
                                        placeholder={I18n.t("account.phoneNumber")}
                                        size="12"
                                        normalize={Utilities.normalizePhone}
                                        component={this.renderTextField}
                                    />
                                    <Field
                                        name="Password"
                                        type="password"
                                        label={I18n.t("account.password")}
                                        placeholder={I18n.t("account.password")}
                                        size="12"
                                        component={this.renderTextField}
                                    />
                                    <Field
                                        name="ConfirmPassword"
                                        type="password"
                                        label={I18n.t("account.confirmPassword")}
                                        placeholder={I18n.t("account.confirmPassword")}
                                        size="12"
                                        component={this.renderTextField}
                                    />
                                </div>
                            </div>
                            <div className="col-md-6">
                                <div className="row">
                                    <div className="col-md-12">
                                        <label><Translate value="address.country" /></label>
                                        <div className="input-select">
                                            <Field name="CountryId" value={countries.length > 0 ? countries[0].id : 0} component="select" onChange={e => this.onCountryChange(e.target.value)}>
                                                {this.renderCountries()}
                                            </Field>
                                        </div>
                                    </div>
                                    <div className="col-md-12">
                                        <label><Translate value="address.state" /></label>
                                        <div className="input-select">
                                            <Field name="StateId" value={states.length > 0 ? states[0].id : 0} component="select" >
                                                {this.renderStates()}
                                            </Field>
                                        </div>
                                    </div>
                                    <Field
                                        name="City"
                                        type="text"
                                        label={I18n.t("address.city")}
                                        placeholder={I18n.t("address.city")}
                                        size="12"
                                        component={this.renderTextField}
                                    />
                                    <Field
                                        name="Address1"
                                        type="text"
                                        label={I18n.t("address.address1")}
                                        placeholder={I18n.t("address.address1")}
                                        size="12"
                                        component={this.renderTextField}
                                    />
                                    <Field
                                        name="Address2"
                                        type="text"
                                        label={I18n.t("address.address2")}
                                        placeholder={I18n.t("address.address2")}
                                        size="12"
                                        component={this.renderTextField}
                                    />
                                    <Field
                                        name="ZipPostalCode"
                                        type="text"
                                        label={I18n.t("address.postalCode")}
                                        placeholder={I18n.t("address.postalCode")}
                                        size="12"
                                        component={this.renderTextField}
                                    />
                                </div>
                            </div>

                            {this.renderErrors()}
                        </div>
                    </div>
                </div>
                <WizardActionButtons showPrev={true} showNext={true} goPrev={goPrev} wizardName={wizardName} submitting={submitting} />
            </form>
        );
    }
}

function mapStateToProps(state) {
    return {
        i18n: state.i18n,
        countries: state.countries,
        states: state.states,
        addresses: state.addresses,
        registerStatus: state.registerStatus
    };
}

function mapDispatchToProps(dispatch) {
    return bindActionCreators({
        getXsrfToken: getXsrfToken,
        getUserInfo: getUserInfo,
        register: register,
        getStates: getStates,
        getAddresses: getAddresses,
        toggleBlockingStatus: toggleBlockingStatus
    }, dispatch)
}

function validate(values) {
    const errors = {};

    if (!values.FirstName) {
        errors.FirstName = I18n.t("validation.account.firstName.required");
    }
    if (!values.LastName) {
        errors.LastName = I18n.t("validation.account.lastName.required");
    }

    if (!values.UserName) {
        errors.UserName = I18n.t("validation.account.email.required");
    } else if (!/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i.test(values.UserName)) {
        errors.UserName = I18n.t("validation.account.email.email");
    }

    if (!values.PhoneNumber) {
        errors.PhoneNumber = I18n.t("validation.account.phoneNumber.required");
    } else if (!/^\(?\d{3}\)?[ ]?\d{3}[- ]?\d{4}$/i.test(values.PhoneNumber)) {
        errors.PhoneNumber = I18n.t("validation.account.phoneNumber.number");
    }

    if (!values.Company) {
        errors.Company = I18n.t("validation.account.company.required");
    }

    if (!values.Password) {
        errors.Password = I18n.t("validation.account.password.required");
    }
    if (!values.ConfirmPassword) {
        errors.ConfirmPassword = I18n.t("validation.account.confirmPassword.required");
    }
    if (values.Password && values.ConfirmPassword && values.Password !== values.ConfirmPassword) {
        errors.ConfirmPassword = I18n.t("validation.account.confirmPassword.match");
    }

    if (!values.City) {
        errors.City = I18n.t("validation.address.city.required");
    }
    if (!values.Address1) {
        errors.Address1 = I18n.t("validation.address.address1.required");
    }
    if (!values.ZipPostalCode) {
        errors.ZipPostalCode = I18n.t("validation.address.postalCode.required");
    }

    return errors;
}

export default reduxForm({
    validate,
    form: "CheckoutForm",
    destroyOnUnmount: false,
    forceUnregisterOnUnmount: true
})(
    connect(mapStateToProps, mapDispatchToProps)(CreateAccountForm)
);
